module.exports = new __parcel__URL__("LandInEditorBannerBackgroundLight.5f156b32.svg").toString();